import React, { useMemo } from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import CruiseShipFacts from './CruiseShipFacts'

interface Props { offer: App.CruiseOffer }

function CruiseShipOverview({ offer }: Props) {
  const shipImages = offer.ship.images || []

  const ageRestrictions = useMemo(() => {
    const { minimumSupervisorAge, adultMinimumAge } = offer.ship.occupancies || {}
    if (minimumSupervisorAge && adultMinimumAge) {
      return `Age restrictions: passengers under ${adultMinimumAge} must travel with a guardian aged ${minimumSupervisorAge} or older.`
    }
  }, [offer.ship.occupancies])

  return <Group direction="horizontal" horizontalAlign="stretch" gap={48}>
    <Group direction="vertical" gap={20}>
      <CSSBreakpoint max="tablet">
        <ImageGallery
          images={shipImages}
          showImageTitles={false}
        />
      </CSSBreakpoint>

      <Group direction="vertical" gap={8}>
        <Heading as="h4" variant="heading3">
          {offer.ship.name}
        </Heading>
        <BodyText variant="medium"><span>{offer.cruiseLine.name}</span></BodyText>
      </Group>

      <Group direction="vertical" gap={16} horizontalAlign="start">
        <CruiseShipFacts offer={offer} />
      </Group>

      {ageRestrictions && <MessageBanner
        icon={<LineInfoCircleIcon />}
        description={ageRestrictions}
        kind="informational-primary"
      />}
    </Group>

    <CSSBreakpoint min="desktop">
      <ImageGallery
        images={shipImages}
        showImageTitles={false}
      />
    </CSSBreakpoint>
  </Group>
}

export default CruiseShipOverview
